<app-context-menu #rowContextMenu *ngIf="(dataSourceDataObj | async) && shouldShowContextMenu" (closed)="contextMenuSelection = null"></app-context-menu>
<app-context-menu #freezeContextMenu></app-context-menu>

<div *ngIf="displayedColumns != null && displayedColumns.length == 0" class="center mt-3 mb-3">
  <h1>{{ 'noColumnsToDisplay' | translate }}</h1>
</div>
<div class="h-100 w-100 table-wrap" [ngClass]="frozenWrapperClass" appResizeObserver (resized)="resizeExtendedContainer($event)" [enableResize]="resizeExpandedStatus">
  <div class="table-flex-area">
  <div class="table-main-column">
  <!-- wrapper z position:relative — kontekst pozycjonowania dla cancel-loading-btn -->
  <div class="table-ptable-wrapper" [class.paginator-no-data]="currentDataCount === 0">
  <p-table #table [value]="dataSourceDataObj | async" [columns]="displayedColumns" [lazy]="true" [lazyLoadOnInit]="false"
    [reorderableColumns]="true"
    (onColReorder)="columnReorder($event)" (onPage)="onPage($event)" [resetPageOnSort]="true" (onSort)="onSort($event)"
    [virtualScroll]="true" [virtualRowHeight]="tableRowHeight" [minBufferPx]="minBufferPx" [maxBufferPx]="maxBufferPx"
    [scrollable]="true" [scrollHeight]="tableScrollHeight" styleClass="p-datatable-gridlines"
    [rows]="showPagination ? paginationSize : null" [rowsPerPageOptions]="rowsPerPageOptions" [paginator]="paginatorVisible"
    [totalRecords]="matDataSource?.dataCount$ | async" [loading]="matDataSource?.loading$ | async" selectionMode="{{selectionType}}"
    [(selection)]="selection" sortMode="multiple" [dataKey]="dataKeyForTable" [(contextMenuSelection)]="contextMenuSelection" [virtualScrollDelay]="0"
    (contextmenu)="onContextMenuSelected($event)" *ngIf="displayTable" [metaKeySelection]="true" [rowTrackBy]="trackBy">

    <ng-template pTemplate="paginatorleft">
      <span class="go-to-page-label" [class.disabled]="currentDataCount === 0" (click)="goToPage(pageInput)">{{ 'goToPage' | translate}}</span>
      <input class="go-to-page-input" type="number"
              pInputText
              [(ngModel)]="pageInput"
              [min]="1"
              [max]="999999"
              [disabled]="currentDataCount === 0"
              (keydown.enter)="goToPage(pageInput)"/>
    </ng-template>

    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of columns" [ngStyle]="getColgroupWidthStyle(col.name)">
      </colgroup>
    </ng-template>

    <ng-template pTemplate="caption" *ngIf="captionVisible">
      <div class="caption" [attr.data-column]="'header-caption'">
        <div class="caption-button-panel">

          <div class="caption-button-group">

            <mat-icon class="cursor-pointer" svgIcon="search"
               [matTooltip]="'table-nav.go-to-col' | translate"
               [appPanelTrigger]="navGoToColumnPanelTpl" #navGoToColumnPanel="appPanelTrigger"
               (click)="navGoToColumnPanel.toggle()"
               (opened)="onNavColOverlayShow()"
               (closed)="navColSelectedIndex = -1">
            </mat-icon>
            <ng-template #navGoToColumnPanelTpl>
              <div class="pt-overlay-panel nav-goto-column-panel">
                <div class="nav-goto-column-search">
                  <i class="pi pi-search nav-goto-column-search-icon"></i>
                  <input #navColSearchInputEl type="text" [(ngModel)]="navColSearchTerm"
                          [placeholder]="'table-nav.search-col' | translate"
                          class="nav-goto-column-search-input"
                          (click)="$event.stopPropagation()"
                          (ngModelChange)="navColSelectedIndex = -1"
                          (keydown)="navColKeyDown($event)" />
                  <i class="pi pi-times cursor-pointer nav-goto-column-clear"
                      *ngIf="navColSearchTerm"
                      (click)="navColSearchTerm = ''; navColSelectedIndex = -1">
                  </i>
                </div>
                <div class="nav-goto-column-list">
                  <div *ngFor="let col of getVisibleColumnsForNav(); let i = index"
                    class="nav-goto-column-item cursor-pointer"
                    [class.nav-goto-column-item-active]="i === navColSelectedIndex"
                    (click)="navGoToColumn(col.name); navGoToColumnPanel.close()">
                    <span>{{ col.title | translate | capitalizeFirst }}</span>
                    <span class="nav-goto-column-pos">{{ getColTablePosition(col.name) }}</span>
                  </div>
                </div>
              </div>
            </ng-template>

            <mat-icon [matTooltip]="'column_visibility' | translate" class="cursor-pointer" svgIcon="view_column"
              [appPanelTrigger]="columnVisibilityPanelTpl" #columnVisibilityPanel="appPanelTrigger"
              [appPanelIgnore]="['pt-context-menu']"
              [appPanelDismissDisabled]="isColumnListDragging"
              (click)="openColumnVisibilityOverlay()"
              (closed)="onColumnVisibilityClosed()"
              [matBadge]="visibleColumnsCount" matBadgeSize="small" matBadgeColor="primary">
            </mat-icon>
            <ng-template #columnVisibilityPanelTpl>
              <div class="pt-overlay-panel column-visibility-panel">
                <div class="column-visibility-header">
                  <button mat-icon-button type="button"
                    (click)="columnHiderListInline.toggleAllChecked()">
                    <mat-icon [svgIcon]="columnHiderListInline.isAllChecked() ? 'event_list_fill' : 'event_list'"></mat-icon>
                  </button>
                  <span class="col-vis-count">{{ pendingVisibleColumnsCount }} / {{ pendingTotalColumnsCount }}</span>
                  <div class="col-vis-header-actions">
                    <button mat-icon-button type="button"
                      (click)="columnVisibilityPanel.close()">
                      <mat-icon svgIcon="close"></mat-icon>
                    </button>
                    <button mat-icon-button type="button"
                      [disabled]="!columnVisibilityFormValid"
                      (click)="saveColumnVisibility()">
                      <mat-icon svgIcon="done"></mat-icon>
                    </button>
                  </div>
                </div>
                <app-column-hider-list #columnHiderListInline
                  [settings]="columnVisibilitySettings"
                  [datasource]="dataSource?.name"
                  [inlineMode]="true"
                  [frozenColumnsCount]="pendingFrozenColumnsCount"
                  [lockedColumnsCount]="lockedColumnsCount"
                  (frozenColumnsCountChange)="pendingFrozenColumnsCount = $event"
                  (changes)="onColumnVisibilityChanged($event)"
                  (draggingChange)="onColumnListDragChange($event)"
                  (closeRequested)="columnVisibilityPanel.close()">
                </app-column-hider-list>
              </div>
            </ng-template>

            <mat-icon *ngIf="columnFilterEnabled" [matTooltip]="'edit-column-filters' | translate" class="cursor-pointer"
              [svgIcon]="appliedFilterCount === 0 ? 'filter_list_off' : 'filter_list'"
              [appPanelTrigger]="filterPanelTpl" #filterPanel="appPanelTrigger"
              [appPanelIgnore]="['cdk-overlay-container']"
              (click)="openFilterOverlay()"
              (contextmenu)="onFilterIconRightClick($event)"
              matBadge="{{ appliedFilterCount }}"
              matBadgeSize="small"
              matBadgeColor="primary"
              [matBadgeHidden]="appliedFilterCount === 0">
            </mat-icon>
            <ng-template #filterPanelTpl>
              <div class="pt-overlay-panel filter-editor-panel">
                <div class="filter-editor-header">
                  <button mat-icon-button type="button"
                    (click)="toggleAllFilterOverlayItems()">
                    <mat-icon [svgIcon]="filterOverlayAllActive ? 'event_list_fill' : 'event_list'"></mat-icon>
                  </button>
                  <span class="filter-key-count">{{ filterOverlayActiveCount }} {{ 'filter-keys' | translate }}</span>
                  <button mat-icon-button type="button" class="filter-apply-btn"
                    [disabled]="!filterOverlayHasChanges"
                    [matTooltip]="'apply-filter-changes' | translate"
                    (click)="applyFiltersFromOverlay()">
                    <mat-icon svgIcon="play_arrow"></mat-icon>
                  </button>
                  <div class="filter-editor-actions">
                    <button mat-icon-button type="button"
                      [disabled]="!filterOverlayHasChanges"
                      [matTooltip]="'reset-filter-changes' | translate"
                      (click)="resetFilterOverlayToApplied()">
                      <mat-icon svgIcon="undo_1"></mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="closeFilterOverlay()">
                      <mat-icon svgIcon="close"></mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="saveFiltersFromOverlay()">
                      <mat-icon svgIcon="done"></mat-icon>
                    </button>
                  </div>
                </div>
                <div class="filter-key-list" *ngIf="filterOverlayItems.length > 0">
                  <div *ngFor="let item of filterOverlayItems; let i = index"
                    class="filter-key-item" [class.filter-key-inactive]="!item.active" [class.filter-key-changed]="isFilterMembershipChanged(i)">
                    <mat-checkbox class="filter-item-checkbox" color="primary"
                      [checked]="item.active"
                      (change)="toggleFilterOverlayItem(i)">
                      {{ getColumnTitle(item.field) | translate | capitalizeFirst }}
                    </mat-checkbox>
                    <div class="filter-value-control" [class.value-changed]="isFilterValueChanged(i)"
                      [attr.data-filter-field]="item.field" [ngSwitch]="getFilterFieldWidget(item.field)">

                      <div class="control-field boolean-control-field" *ngSwitchCase="'boolean'">
                        <mat-checkbox disableRipple [disabled]="!item.active" [(ngModel)]="item.value"></mat-checkbox>
                      </div>

                      <app-column-filter-value class="control-field" *ngSwitchCase="'value-list'"
                        [name]="item.field" [options]="getFilterFieldOptions(item.field)"
                        [emptyOptionLabel]="getFilterFieldEmptyOptionLabel(item.field)"
                        [allowText]="!getFilterFieldOptions(item.field)"
                        [(ngModel)]="item.value" [disabled]="!item.active"></app-column-filter-value>

                      <mat-form-field class="control-field" *ngSwitchDefault appearance="outline">
                        <input fxFlex matInput [type]="getFilterNativeInputType(item.field)" [(ngModel)]="item.value"
                          [disabled]="!item.active" (keydown.enter)="onFilterValueEnter($event)">
                        <mat-icon *ngIf="getFilterNativeInputType(item.field) === 'search'" svgIcon="search"></mat-icon>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="filter-add-section" *ngIf="columnsNotInFilterOverlay.length > 0">
                  <div class="filter-add-search-row">
                    <i class="pi pi-search filter-add-search-icon"></i>
                    <input #filterAddSearchInputEl type="text" class="filter-add-input" [(ngModel)]="filterAddSearch"
                      [placeholder]="'table-nav.search-col' | translate"
                      (ngModelChange)="filterAddSelectedIndex = -1"
                      (keydown)="filterAddKeyDown($event)" />
                    <i class="pi pi-times cursor-pointer filter-add-search-clear"
                        *ngIf="filterAddSearch"
                        (click)="filterAddSearch = ''; filterAddSelectedIndex = -1; $event.stopPropagation()">
                    </i>
                  </div>
                  <div class="filter-add-results" *ngIf="filteredColumnsToAddFilter.length > 0">
                    <div *ngFor="let col of filteredColumnsToAddFilter; let i = index" class="filter-add-result-item"
                      [class.filter-add-result-item-active]="i === filterAddSelectedIndex"
                      [class.filter-add-result-item-disabled]="isColumnFilterUnsupported(col)"
                      [matTooltip]="isColumnFilterUnsupported(col) ? ('filter-type-unsupported' | translate) : null"
                      (click)="pendingFilterAddKey(col.name)">
                      {{ col.title | translate | capitalizeFirst }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>

          </div>

          <ng-container *ngIf="groupingEnabled">
            <div class="caption-button-group">
                <mat-icon class="grouping-caption-button cursor-pointer" svgIcon="group" [style.height.px]="18"
                          [appPanelTrigger]="groupingPanelTpl" #groupingPanel="appPanelTrigger"
                          (click)="openGroupingMenu()"
                          (opened)="onGroupingOverlayShow()"
                          (closed)="groupingSelectedIndex = -1"
                          (contextmenu)="disableGroupingOnRightClick($event)" [matTooltip]="'groupingColumn' | translate"
                          matBadge="1"
                          matBadgeSize="small"
                          matBadgeColor="primary"
                          [matBadgeHidden]="!groupBy">
                </mat-icon>
                <ng-template #groupingPanelTpl>
                  <div class="pt-overlay-panel grouping-column-panel">
                    <div class="grouping-item grouping-no-group-item cursor-pointer"
                      [class.grouping-item-active]="!groupBy"
                      (click)="onSelectGroupingColumn(null); groupingPanel.close()">
                      <i class="pi pi-check grouping-item-check"
                         [style.visibility]="!groupBy ? 'visible' : 'hidden'"></i>
                      <span class="grouping-item-label">{{ 'doNotGroup' | translate }}</span>
                    </div>
                    <div class="grouping-search">
                      <i class="pi pi-search grouping-search-icon"></i>
                      <input #groupingSearchInputEl type="text" [(ngModel)]="groupingSearchTerm"
                             [placeholder]="'table-nav.search-col' | translate"
                             class="grouping-search-input"
                             (click)="$event.stopPropagation()"
                             (ngModelChange)="groupingSelectedIndex = -1"
                             (keydown)="groupingKeyDown($event)" />
                      <i class="pi pi-times cursor-pointer grouping-search-clear"
                         *ngIf="groupingSearchTerm"
                         (click)="groupingSearchTerm = ''; groupingSelectedIndex = -1; $event.stopPropagation()">
                      </i>
                    </div>
                    <div class="grouping-list">
                      <div *ngFor="let col of filteredGroupingColumns; let i = index; trackBy: trackByGroupingColumnName"
                        class="grouping-item cursor-pointer"
                        [class.grouping-item-active]="col.name === groupBy"
                        [class.grouping-item-highlighted]="i === groupingSelectedIndex"
                        (click)="onSelectGroupingColumn(col.name); groupingPanel.close()">
                        <i class="pi pi-check grouping-item-check"
                           [style.visibility]="col.name === groupBy ? 'visible' : 'hidden'"></i>
                        <span class="grouping-item-label">{{ col.label }}</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <i *ngIf="groupBy" class="pi cursor-pointer" [ngClass]="areAnyGroupsExpanded ? 'pi-chevron-up' : 'pi-chevron-down'" (click)="toggleAllGroups()" [matTooltip]="(areAnyGroupsExpanded ? 'collapseAllGroups' : 'expandAllGroups') | translate"></i>
            </div>
          </ng-container>

          <div class="caption-button-group">
            <mat-icon [matTooltip]="'edit-sort' | translate" class="cursor-pointer" [svgIcon]="appliedSortMeta.length === 0 ? 'sort-alt-slash' : 'sort-alt'"
              [appPanelTrigger]="sortPanelTpl" #sortPanel="appPanelTrigger"
              [appPanelDismissDisabled]="isSortListDragging"
              (click)="openSortOverlay()"
              (contextmenu)="onSortIconRightClick($event)"
              matBadge="{{ appliedSortMeta.length }}"
              matBadgeSize="small"
              matBadgeColor="primary"
              [matBadgeHidden]="appliedSortMeta.length === 0">
            </mat-icon>
            <ng-template #sortPanelTpl>
              <div class="pt-overlay-panel sort-editor-panel">
                <div class="sort-editor-header">
                  <button mat-icon-button type="button"
                    (click)="toggleAllSortOverlayItems()">
                    <mat-icon [svgIcon]="sortOverlayAllActive ? 'event_list_fill' : 'event_list'"></mat-icon>
                  </button>
                  <span class="sort-key-count">{{ sortOverlayActiveCount }} {{ 'sort-keys' | translate }}</span>
                  <div class="sort-editor-actions">
                    <button mat-icon-button type="button"
                      [disabled]="!sortOverlayHasChanges"
                      [matTooltip]="'reset-sort-changes' | translate"
                      (click)="resetSortOverlayToApplied()">
                      <mat-icon svgIcon="undo_1"></mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="closeSortOverlay()">
                      <mat-icon svgIcon="close"></mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="saveSortFromOverlay()">
                      <mat-icon svgIcon="done"></mat-icon>
                    </button>
                  </div>
                </div>
                <div class="sort-key-list" cdkDropList (cdkDropListDropped)="pendingSortDrop($event)"
                  *ngIf="sortOverlayItems.length > 0">
                  <div *ngFor="let item of sortOverlayItems; let i = index"
                    class="sort-key-item" [class.sort-key-inactive]="!item.active" [class.sort-key-new]="isSortKeyNew(i)" cdkDrag
                    (cdkDragStarted)="isSortListDragging = true"
                    (cdkDragEnded)="onSortListDragEnd()">
                    <mat-icon class="sort-drag-handle" cdkDragHandle svgIcon="drag_indicator"></mat-icon>
                    <span class="sort-key-index" [class.mat-accent]="isSortKeyPositionChanged(i) || isSortKeyNew(i)">{{ getSortKeyNumber(i) ?? '' }}</span>
                    <mat-checkbox class="sort-item-checkbox" color="primary"
                      [checked]="item.active"
                      (change)="toggleSortOverlayItem(i)">
                      {{ getColumnTitle(item.field) | translate | capitalizeFirst }}
                    </mat-checkbox>
                    <ng-container *ngIf="item.active">
                      <button mat-icon-button type="button" class="sort-dir-btn"
                        [class.active]="item.order === 1"
                        [color]="(isSortKeyDirectionChanged(i) || isSortKeyNew(i)) ? 'accent' : null"
                        [matTooltip]="'asc' | translate"
                        (click)="pendingSortSetDir(i, 1)">
                        <i class="pi pi-sort-amount-up-alt"></i>
                      </button>
                      <button mat-icon-button type="button" class="sort-dir-btn"
                        [class.active]="item.order === -1"
                        [color]="(isSortKeyDirectionChanged(i) || isSortKeyNew(i)) ? 'accent' : null"
                        [matTooltip]="'desc' | translate"
                        (click)="pendingSortSetDir(i, -1)">
                        <i class="pi pi-sort-amount-down"></i>
                      </button>
                    </ng-container>
                  </div>
                </div>
                <div class="sort-add-section" *ngIf="sortableColumnsNotInOverlay.length > 0">
                  <div class="sort-add-search-row">
                    <i class="pi pi-search sort-add-search-icon"></i>
                    <input type="text" class="sort-add-input" [(ngModel)]="sortAddSearch"
                      [placeholder]="'table-nav.search-col' | translate"
                      (ngModelChange)="sortAddSelectedIndex = -1"
                      (keydown)="sortAddKeyDown($event)" />
                    <i class="pi pi-times cursor-pointer sort-add-search-clear"
                       *ngIf="sortAddSearch"
                       (click)="sortAddSearch = ''; sortAddSelectedIndex = -1; $event.stopPropagation()">
                    </i>
                  </div>
                  <div class="sort-add-results" *ngIf="filteredColumnsToAdd.length > 0">
                    <div *ngFor="let col of filteredColumnsToAdd; let i = index" class="sort-add-result-item"
                      [class.sort-add-result-item-active]="i === sortAddSelectedIndex"
                      (click)="pendingSortAddKey(col.name)">
                      {{ col.title | translate | capitalizeFirst }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <mat-icon [matTooltip]="(!selectableSort ? 'auto-confirm-sort' : 'manual-confirm-sort') | translate"
              (click)="toggleSortMode()" class="cursor-pointer" [svgIcon]="!selectableSort ? 'autoplay' : 'autopause'">
            </mat-icon>
            <mat-icon *ngIf="selectableSort" [matTooltip]="'confirm-sort' | translate"
              class="cursor-pointer" svgIcon="play_arrow" (click)="toggleSort()" (contextmenu)="onConfirmSortRightClick($event)"
              matBadge="{{ changedSortCount }}"
              matBadgeSize="small"
              matBadgeColor="accent"
              [matBadgeHidden]="changedSortCount === 0">
            </mat-icon>
          </div>

          <div class="caption-button-group">
            <ng-container *ngIf="!groupBy && !expandableDeviceStatusRow && !expandableSnvrTask">
              <i [matTooltip]="'local-print.print-to-file' | translate" class="pi pi-print cursor-pointer"
                 [appPanelTrigger]="printMenuTpl" #printMenu="appPanelTrigger" (click)="openPrintMenu()">
              </i>
              <ng-template #printMenuTpl>
                <div class="pt-overlay-panel print-panel">
                  <div class="print-scope-section">
                    <span class="print-section-label">{{ 'local-print.scope' | translate }}</span>
                    <div class="print-scope-buttons">
                      <button pButton class="p-button-sm print-scope-btn" [class.p-button-outlined]="printScope !== 'page'"
                        [disabled]="exportService.isBusy$ | async" (click)="printScope = 'page'">
                        {{ 'local-print.scope-page' | translate }}
                      </button>
                      <button pButton class="p-button-sm print-scope-btn"
                        [class.p-button-outlined]="printScope !== 'selection'"
                        [disabled]="(exportService.isBusy$ | async) || selectionType !== 'multiple' || !selection?.length" (click)="printScope = 'selection'">
                        {{ 'local-print.scope-selection' | translate }}
                      </button>
                      <button pButton class="p-button-sm print-scope-btn"
                        [class.p-button-outlined]="printScope !== 'all'"
                        [disabled]="(exportService.isBusy$ | async) || remoteDataType !== 'rest'" (click)="printScope = 'all'">
                        {{ 'local-print.scope-all' | translate }}
                      </button>
                    </div>
                  </div>
                  <div class="print-large-data-warning" *ngIf="printScope === 'all' && currentDataCount > LARGE_DATA_THRESHOLD">
                    <i class="pi pi-exclamation-triangle"></i>
                    {{ 'local-print.large-data-warning' | translate:{count: currentDataCount} }}
                  </div>
                  <div class="print-buttons">
                    <button pButton [disabled]="(printService.isPdfBusy$ | async) || (exportService.isBusy$ | async) || !(dataSourceDataObj | async).length"
                      (click)="printWithScope('pdf')" class="p-button-text p-button-plain">
                      <span class="print-button-label">
                        <i class="pi pi-file-pdf mr-2"></i>
                        <span>{{ 'PDF' | translate }}</span>
                      </span>
                      <span *ngIf="printService.isPdfBusy$ | async" class="flex flex-row ml-2">
                        <i class="pi pi-spin pi-spinner"></i>
                        <span class="ml-1 text-xs">
                          {{ (printService.pdfProgress$ | async) <= 100 ? ((printService.pdfProgress$ | async) + '%' ) : ('local-print.finalizing' | translate) }}
                        </span>
                      </span>
                    </button>
                    <button pButton [disabled]="(printService.isExcelBusy$ | async) || (exportService.isBusy$ | async) || !(dataSourceDataObj | async).length"
                      (click)="printWithScope('xlsx')" class="p-button-text p-button-plain">
                      <span class="print-button-label">
                        <i class="pi pi-file-excel mr-2"></i>
                        <span>{{ 'XLSX' | translate }}</span>
                      </span>
                      <span *ngIf="printService.isExcelBusy$ | async" class="flex flex-row ml-2">
                        <i class="pi pi-spin pi-spinner"></i>
                        <span class="ml-1 text-xs">
                          {{ (printService.excelProgress$ | async) <= 100 ? ((printService.excelProgress$ | async) + '%' ) : ('local-print.finalizing' | translate) }}
                        </span>
                      </span>
                    </button>
                    <button pButton [disabled]="(exportService.isBusy$ | async) || !(dataSourceDataObj | async).length"
                      (click)="printWithScope('csv')" class="p-button-text p-button-plain">
                      <span class="print-button-label">
                        <i class="pi pi-file mr-2"></i>
                        <span>CSV</span>
                      </span>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <mat-icon class="cursor-pointer" svgIcon="page_info" style="height: 20px"
                [matTooltip]="'viewSettings' | translate"
                [appPanelTrigger]="viewSettingsMenuTpl" #viewSettingsMenu="appPanelTrigger"
                (click)="viewSettingsMenu.toggle()">
            </mat-icon>
            <ng-template #viewSettingsMenuTpl>
              <div class="pt-overlay-panel view-settings-panel">
                <div class="view-settings-items">
                  <div class="view-settings-row">
                    <mat-checkbox class="view-settings-checkbox" color="primary"
                                  [checked]="columnFilterEnabled && columnFilterVisible"
                                  [disabled]="!columnFilterEnabled"
                                  (change)="toggleColumnFilter()">
                      {{ 'filterBar' | translate }}
                    </mat-checkbox>
                    <button mat-icon-button class="view-settings-action-btn"
                            [disabled]="!columnFilterEnabled"
                            (click)="clearAllColumnFilters()"
                            [matTooltip]="'clearFilters' | translate">
                      <mat-icon svgIcon="search_off"></mat-icon>
                    </button>
                  </div>
                  <mat-checkbox class="view-settings-checkbox" color="primary"
                                [checked]="showPagination && !paginationUserHidden"
                                [disabled]="!showPagination"
                                (change)="togglePagination()">
                    {{ 'paginationBar' | translate }}
                  </mat-checkbox>
                  <div class="view-settings-row">
                    <mat-checkbox class="view-settings-checkbox" color="primary"
                                  [checked]="showMinimap && minimapUserVisible"
                                  [disabled]="!showMinimap"
                                  (change)="toggleMinimap()">
                      {{ 'minimap' | translate }}
                    </mat-checkbox>
                    <button mat-icon-button class="view-settings-action-btn"
                            [disabled]="!showMinimap || !minimapUserVisible"
                            (click)="fitMinimapToWidth()"
                            [matTooltip]="'fitMinimapToWidth' | translate">
                      <mat-icon svgIcon="fit_screen"></mat-icon>
                    </button>
                  </div>
                  <mat-checkbox class="view-settings-checkbox" color="primary"
                                [checked]="showRowRuler && rowRulerVisible"
                                [disabled]="!showRowRuler"
                                (change)="toggleRowRuler()">
                    {{ 'rowRuler' | translate }}
                  </mat-checkbox>
                </div>
              </div>
            </ng-template>
          </div>

        </div>

        <div *ngIf="navButtonsEnabled" class="nav-center">
          <div class="nav-subpanel" [class.nav-subpanel-open]="navPanelOpen">
            <i class="pi pi-fast-backward cursor-pointer" [class.nav-btn-disabled]="navAtFirstCol" [matTooltip]="'table-nav.first-col' | translate" (click)="navFirstColumn()"></i>
            <i class="pi pi-step-backward cursor-pointer" [class.nav-btn-disabled]="navAtFirstCol" [matTooltip]="'table-nav.page-left' | translate" (click)="navColumnPageLeft()"></i>
            <i class="pi pi-caret-left cursor-pointer" [class.nav-btn-disabled]="navAtFirstCol" [matTooltip]="'table-nav.col-left' | translate" (click)="navColumnLeft()"></i>
            <i class="pi pi-caret-right cursor-pointer" [class.nav-btn-disabled]="navAtLastCol" [matTooltip]="'table-nav.col-right' | translate" (click)="navColumnRight()"></i>
            <i class="pi pi-step-forward cursor-pointer" [class.nav-btn-disabled]="navAtLastCol" [matTooltip]="'table-nav.page-right' | translate" (click)="navColumnPageRight()"></i>
            <i class="pi pi-fast-forward cursor-pointer" [class.nav-btn-disabled]="navAtLastCol" [matTooltip]="'table-nav.last-col' | translate" (click)="navLastColumn()"></i>
          </div>
          <i class="pi pi-compass cursor-pointer"
             [class.nav-panel-active]="navPanelOpen"
             [matTooltip]="'table-nav.nav-open' | translate"
             (click)="toggleNavPanel()">
          </i>
          <div class="nav-subpanel nav-subpanel-row" [class.nav-subpanel-open]="navPanelOpen">
            <i class="pi pi-fast-backward cursor-pointer" [class.nav-btn-disabled]="navAtFirstRow" [matTooltip]="'table-nav.first-row' | translate" (click)="navFirstRow()"></i>
            <i class="pi pi-step-backward cursor-pointer" [class.nav-btn-disabled]="navAtFirstRow" [matTooltip]="'table-nav.page-up' | translate" (click)="navRowPageUp()"></i>
            <i class="pi pi-caret-left cursor-pointer" [class.nav-btn-disabled]="navAtFirstRow" [matTooltip]="'table-nav.row-up' | translate" (click)="navRowUp()"></i>
            <i class="pi pi-caret-right cursor-pointer" [class.nav-btn-disabled]="navAtLastRow" [matTooltip]="'table-nav.row-down' | translate" (click)="navRowDown()"></i>
            <i class="pi pi-step-forward cursor-pointer" [class.nav-btn-disabled]="navAtLastRow" [matTooltip]="'table-nav.page-down' | translate" (click)="navRowPageDown()"></i>
            <i class="pi pi-fast-forward cursor-pointer" [class.nav-btn-disabled]="navAtLastRow" [matTooltip]="'table-nav.last-row' | translate" (click)="navLastRow()"></i>
          </div>
        </div>

        <div class="selection-banner" *ngIf="selectionType === 'multiple'">
          <span>{{('selectedElements' | translate) + ': ' + selection.length}}</span>
          <mat-icon class="cursor-pointer" [svgIcon]="allPageRowsSelected ? 'event_list_fill' : 'event_list'" (click)="toggleSelectAllPageRows()" [matTooltip]="(allPageRowsSelected ? 'deselectAll' : 'selectAll') | translate"></mat-icon>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr *ngIf="groupingHeaderEnabled && groupingHeaders">
        <th colspan="1" class="no-grouping ellipsis" [attr.data-column]="'header-grouping'"></th>
        <th *ngFor="let row of groupingHeaders" [attr.data-column]="'header-grouping'" [attr.colspan]="row.colspan" class="{{row.name ? 'grouping' : 'no-grouping'}} ellipsis">
          <span>{{row.name | translate}}</span>
        </th>
      </tr>
      <tr *ngIf="columnFilterEnabled && columnFilterVisible">
        <!-- BEZ pReorderableColumn: aktywna dyrektywa dawała kursor "move", robiła z komórki źródło
             (mousedown → draggable) i cel dropu reorder — a wiersz filtrów nie bierze udziału w liczeniu
             indeksów (indexWithinGroup działa per-wiersz i pozostałe th filtrów atrybutu nie mają). -->
        <th *ngIf="checkIfOptionColumnExists()" [attr.data-column]="'options'" class="options-row-cell column-filter">
          <app-clear-filter></app-clear-filter>
        </th>
        <ng-container *ngFor="let col of columns">
          <th *ngIf="col.name != 'options'" [attr.data-column]="'header-filter'" class="ellipsis column-filter">
            <app-column-filter *ngIf="!isColumnFilterUnsupported(col)" [name]="col.name" [field]="findFieldByName(col.name)"></app-column-filter>
          </th>
        </ng-container>
      </tr>
      <tr>
        <th *ngIf="checkIfOptionColumnExists()" [attr.data-column]="'options'" (click)="openTableSettings()"
          pReorderableColumn [pReorderableColumnDisabled]="true"
          matTooltip="{{ 'column_visibility' | translate }}" class="options-row-cell cursor-pointer">
          <mat-icon svgIcon="tune" style="height: 20px; vertical-align: middle; line-height: 1 !important; cursor: pointer;"></mat-icon>
        </th>
        <ng-container *ngFor="let col of columns">
          <!-- Kolumna przypięta (col.locked): reorder wyłączony flagą, ale atrybut pReorderableColumn musi
               zostać, bo PrimeNG liczy po nim indeksy kolumn. -->
          <th *ngIf="col.name != 'options'" pReorderableColumn [pReorderableColumnDisabled]="col.locked"
            [pSortableColumnDisabled]="!col.sortable"
            [pSortableColumn]="col.name" class="ellipsis" [attr.data-column]="col.name"
            [class.locked-column-cell]="col.locked">
            <p-sortIcon *ngIf="col.sortable" [field]="col.name"></p-sortIcon>
            <span *ngIf="groupBy == col.name" class="ml-1">
              <mat-icon svgIcon="group" class="group"></mat-icon>
            </span>
            <mat-icon *ngIf="col.headerIcon; else columnTitle" [svgIcon]="col.headerIcon" class="header-icon"
              [matTooltip]="col.title | translate | capitalizeFirst"></mat-icon>
            <ng-template #columnTitle>
              <span class="ml-1">{{ col.title | translate | capitalizeFirst }}</span>
            </ng-template>
            <!-- Własny uchwyt resize (na prawej krawędzi). Zmienia szerokość TYLKO tej kolumny.
                 mousedown zatrzymujemy dla lewego przycisku niezależnie od pointerdown (fallback, gdyby
                 silnik nie stłumił pochodnego mousedown po preventDefault na pointerdown) — inaczej
                 wystartowałby reorder: ReorderableColumn.onMouseDown wyklucza tylko własną klasę
                 p-column-resizer, naszego uchwytu nie zna i ustawiłby th.draggable = true. -->
            <span *ngIf="!col.locked" class="pt-column-resizer" (pointerdown)="startColumnResize($event, col.name)"
              (mousedown)="$event.button === 0 ? $event.stopPropagation() : null"
              (click)="$event.stopPropagation()"></span>
          </th>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded" *ngIf="!groupBy">
      <!-- Klasy zaznaczenia liczone z bieżącego wiersza: bindingi szablonowe są nadrzędne wobec
           host-bindingów pSelectableRow/pContextMenuRow, których stan `selected` (liczony tylko
           w ngOnInit i na zdarzeniach selekcji) zostaje po poprzednim wierszu, gdy widok wraca
           z recyklingu (virtualViewCacheSize > 0). -->
      <tr [pSelectableRow]="row" [pContextMenuRow]="row" [pSelectableRowIndex]="rowIndex" [pRowToggler]="row"
        [class.p-highlight]="isRowSelected(row)" [class.p-highlight-contextmenu]="isRowContextMenuHighlighted(row)"
        (contextmenu)="onRowRightClick($event, row); $event.stopPropagation()"
        (keydown)="rowKey($event, row, rowIndex)" (click)="rowSelected(row); rowFocus.emit(row)"
        (dblclick)="rowDoubleClicked.emit(row)"
        class="{{ dataSource?.tableRowFormatter?.createElementCssClasses(row) }}" app-content-row-columns [columns]="columns" [row]="row"
        [expandableDeviceStatusRow]="expandableDeviceStatusRow" [hasMenuOptions]="hasMenuOptionsForRow(row)"
        [cellFormatters]="dataSource?.tableCellFormatters" (contextMenuSelected)="onContextMenuSelected($event.event, $event.data)"
        [expanded]="expanded" (invokeRefresh)="refreshData()" (rowButtonClicked)="rowButtonClicked.emit($event)"
        [expandableSnvrTask]="expandableSnvrTask" [iconMenuCreator]="dataSource?.iconMenuCreator" (violationClicked)="violationClicked.emit($event)"
        [optionsCellCreator]="optionsCellCreator" [rowIndex]="rowIndex" [showRowNumbers]="showRowNumbers">
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-row let-columns="columns" *ngIf="!groupBy && expandableDeviceStatusRow">
      <tr class="device-status-expansion-row">
        <td class="br-0"></td>
        <td [attr.colspan]="columns.length - 1" class="bl-0">
          <div [style.width]="extendedContainerWidth > 0  ? extendedContainerWidth + 'px' : '100%'">
            <div fxLayout="row wrap" class="device-status-expansion" class="p-1"
              *ngIf="expandableRowDataSources[row.device.deviceType]; else noExpansionDataSource">
              <div *ngFor="let field of expandableRowDataSources[row.device.deviceType].fields" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50"
                fxFlex.lg="50" fxFlex.xl="33">
                <div fxLayout="row" *ngIf="field.column.name !== 'rowId'">
                  <div fxFlex="35">{{ field.column.name | translate }}:</div>
                  <div fxFlex="65" class="value pe-2" style="white-space: normal;">
                    <ng-container *ngIf="field.column.translatable; else showValue">
                      {{ field.column.format(row[field.column.name]) | translateExt }}
                    </ng-container>
                    <ng-template #showValue>
                      {{ field.column.format(row[field.column.name]) }}
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <app-vehicle-layout-view *ngIf="isAdditionalInfo(row)" [editableMode]="false" [additionalInfoImpls]="[row]" [vehicle]="row.vehicle"
            [singleLocation]="true">
          </app-vehicle-layout-view>
          <ng-template #noExpansionDataSource>
            {{ 'noDetails' | translate }}
          </ng-template>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-row let-columns="columns" *ngIf="!groupBy && expandableSnvrTask">
      <tr class="device-status-expansion-row">
        <td class="br-0"></td>
        <td [attr.colspan]="columns.length - 1" class="bl-0">
          <ng-container *ngFor="let rec of row.recordings">
            <div fxLayout="row wrap" class="device-status-expansion snvr-task-expansion" *ngIf="row.recordings; else noExpansionDataSource">
              <div *ngFor="let field of expandableRowDataSources['recordings'].fields" fxFlex>
                <div fxLayout="column">
                  <div fxFlex="50">{{ field.column.name | translate }}:</div>
                  <div fxFlex="50" class="value">
                    <ng-container *ngIf="field.column.translatable; else showValue">
                      {{ field.column.format(rec[field.column.name]) | translateExt }}
                    </ng-container>
                    <ng-template #showValue>
                      {{ field.column.format(rec[field.column.name]) }}
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noExpansionDataSource>
              {{ 'noDetails' | translate }}
            </ng-template>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns" *ngIf="groupBy">
      <ng-container *ngIf="isGroupHeader(row); else groupDataRow">
        <tr (click)="onGroupHeaderClick(row)" class="cursor-pointer">
          <td class="cursor-pointer group-header-chevron">
            <i class="pi" [ngClass]="{ 'pi-chevron-right': !expandedGroups.has(row.groupName), 'pi-chevron-down': expandedGroups.has(row.groupName) }"></i>
          </td>
          <td [attr.colspan]="columns.length - 1" class="cursor-pointer">
            <ng-container *ngIf="cachedGroupByField?.groupingValueTranslatable; else showGroupingHeader">
              <span class="group-name">{{ cachedGroupByField?.groupingValueFormat(row.groupName) | translate}}</span>
            </ng-container>
            <ng-template #showGroupingHeader>
              <span class="group-name">{{ cachedGroupByField?.groupingValueFormat(row.groupName)}}</span>
            </ng-template>
            <ng-container *ngIf="hasGroupSummaryField() || hasGroupSummaryAggregator()">
              <span class="ml-2 group-summary-item" *ngFor="let val of getGroupSummaryValues(row.data)"
                [matTooltip]="getGroupSummaryTooltip() | translate">{{ val }}</span>
            </ng-container>
          </td>
        </tr>
      </ng-container>
      <ng-template #groupDataRow>
        <tr [pContextMenuRow]="row" [class.p-highlight-contextmenu]="isRowContextMenuHighlighted(row)"
          (contextmenu)="onRowRightClick($event, row); $event.stopPropagation()"
          (click)="rowSelected(row); rowFocus.emit(row)" (dblclick)="rowDoubleClicked.emit(row)"
          class="{{ dataSource?.tableRowFormatter?.createElementCssClasses(row) }}" app-content-row-columns [columns]="columns"
          [row]="row" [expandableDeviceStatusRow]="expandableDeviceStatusRow" [contentMenuOptionsMap]="createMenuOptions(row)"
          [cellFormatters]="dataSource?.tableCellFormatters" (contextMenuSelected)="onContextMenuSelected($event.event, $event.data)"
          (rowButtonClicked)="rowButtonClicked.emit($event)" [optionsCellCreator]="optionsCellCreator"
          [hasMenuOptions]="hasMenuOptionsForRow(row)" [rowIndex]="getGroupAwareRowIndex(row, rowIndex)" [showRowNumbers]="showRowNumbers">
        </tr>
      </ng-template>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr class="empty-message-row">
        <td [attr.colspan]="columns.length" class="no-data">
          {{ 'no_data_to_show' | translate }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer" let-columns>
      <tr *ngIf="displayFooter" app-summary [columns]="columns" [isSummaryLoading]="isSummaryLoading" [values]="summaryObject"
        (openSettings)="openSummarySettings()"></tr>
    </ng-template>

  </p-table>
  <!-- cancel-loading-btn wewnątrz wrappera → centruje się w obszarze samej tabeli, bez ruler i minimap -->
  <button *ngIf="matDataSource?.loading$ | async"
          class="cancel-loading-btn"
          (click)="cancelLoading()"
          [title]="'cancelLoading' | translate">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33"><rect width="32" height="33" rx="3.06"/></svg>
  </button>
  </div><!-- /table-ptable-wrapper -->
  <div *ngIf="showMinimap && minimapUserVisible && displayTable"
       [appMinimap]="minimapContext"
       class="table-minimap-container"
       [style.height.px]="minimapHeight"
       [class.table-minimap-dragging]="minimapDragActive"
       [class.table-minimap-resizing]="minimapResizeActive">
    <div class="table-minimap-resize-handle"
         (pointerdown)="minimapDir?.onResizeStart($event)"
         (pointermove)="minimapDir?.onResizeMove($event)"
         (pointerup)="minimapDir?.onResizeEnd()"
         (pointercancel)="minimapDir?.onResizeEnd()">
    </div>
    <canvas class="table-minimap-canvas"
            (pointerdown)="minimapDir?.onPointerDown($event)"
            (pointerup)="minimapDir?.onPointerUp()"
            (pointercancel)="minimapDir?.onPointerUp()"
            (mousedown)="$event.button === 1 && $event.preventDefault()">
    </canvas>
    <div class="table-minimap-viewport"
         [style.transform]="'translateX(' + minimapIndicatorLeft + 'px)'"
         [style.width.px]="minimapIndicatorWidth">
    </div>
  </div>
  <!-- ── Crosshair na głównej tabeli — position:fixed, pozycjonowany przez JS nad scroll containerem ── -->
  <canvas #tableCrosshairCanvas class="table-crosshair-canvas"></canvas>
  <!-- ── Zoom lens minimap — wyświetlany po kliknięciu środkowym przyciskiem ── -->
  <div *ngIf="showMinimapZoom"
       #minimapZoomLens
       class="minimap-zoom-lens"
       [class.minimap-zoom-lens--dragged]="minimapZoomDragged"
       [class.minimap-zoom-lens--pinned]="minimapZoomPinned"
       [style.left.px]="minimapZoomLeft"
       [style.top.px]="minimapZoomTop"
       [style.width.px]="minimapZoomWidth"
       [style.height.px]="minimapZoomHeight">
    <!-- Pasek przeciągania -->
    <div class="zoom-lens-drag-handle"
         (pointerdown)="minimapDir?.startZoomDrag($event)"
         [matTooltip]="'zoomLensDragHint' | translate"
         matTooltipPosition="above"
         matTooltipShowDelay="600">
      <span class="zoom-lens-drag-dots"></span>
    </div>
    <!-- Pinezka: przypięte okno nie zamyka się samo na klik poza nim; ponowny klik odpina i zamyka -->
    <button type="button"
            class="zoom-lens-pin-btn"
            [class.zoom-lens-pin-btn--active]="minimapZoomPinned"
            (pointerdown)="$event.stopPropagation()"
            (click)="minimapDir?.toggleZoomPin($event)"
            [matTooltip]="(minimapZoomPinned ? 'zoomLensUnpinHint' : 'zoomLensPinHint') | translate"
            matTooltipPosition="above"
            matTooltipShowDelay="300">
      <mat-icon>push_pin</mat-icon>
    </button>
    <canvas #minimapZoomCanvas></canvas>
    <!-- Uchwyt zmiany rozmiaru — tylko gdy okno jest przypięte -->
    <div *ngIf="minimapZoomPinned"
         class="zoom-lens-resize-handle"
         (pointerdown)="minimapDir?.startZoomResize($event)"
         [matTooltip]="'zoomLensResizeHint' | translate"
         matTooltipPosition="above"
         matTooltipShowDelay="600">
    </div>
  </div>

  </div><!-- /table-main-column -->
  <div *ngIf="showRowRuler && rowRulerVisible && displayTable"
       class="table-ruler-container">
    <canvas [appRowRuler]="rowRulerContext" class="table-ruler-canvas"></canvas>
  </div>
  </div><!-- /table-flex-area -->
</div>
